module.exports = __webpack_public_path__ + "img/画板 5.b7455fb4.jpg";